<template>
  <Row>
    <Col span="16" style="background: #f8f8f9; min-height: 200px; padding: 16px;">
      <!--字典切换-->
      <div style="width: 100%; padding-bottom: 5px;">
        <Button type="success" style="background-color: darkcyan;">源字典<Icon type="md-arrow-forward" /></Button>
        <Select v-model="dicName" :transfer="true" placeholder="请选择一个源字典" @on-change="sourceChanged"
          style="width: 200px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);" prefix="ios-arrow-down">
          <Option v-for="item in dicNameList" :value="item" :key="item">{{ item }}</Option>
        </Select>&nbsp;&nbsp;
        <Button type="success" style="background-color: darkcyan;">目标字典<Icon type="md-arrow-forward" /></Button>
        <Select v-model="dicId" :transfer="true" placeholder="请选择一个目标字典" @on-change="targetChanged"
          style="width: 300px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);" prefix="ios-arrow-down">
          <Option v-for="item in dicList" :value="item.id" :key="item.id">{{ item.cname + '(' + (item.is_public == '1' ? '公共' : item.appname) + ')' }}</Option>
        </Select>
      </div>
      <!--字典代码列表-->
      <s-DataGrid v-if="isLoadGrid" ref="grid" funcMark="bsp:diccode:list" :customFunc="true" :params="gridParams" :transfer="true">
        <template slot="customHeadFunc" slot-scope="{ func }">
          <Button type="primary"  class="header-button" @click="handleAdd">
            <Icon type="md-add" size="20" />新增
          </Button>&nbsp;
          <Button type="success" :loading="jsLoading" class="com-button" @click="buildJsUpdateCache">
            <Icon type="ios-document-outline" size="20" />更新字典js
          </Button>&nbsp;
          <Button type="error"  class="com-button" :disabled="$refs.grid.batch_select.length < 1" @click="handleDeleteBatch">
            <Icon type="ios-trash-outline" size="20" />删除
          </Button>          
        </template>
        <template slot="customRowFunc" slot-scope="{ func, row, index }">
          <Button type="primary" size="small"  class="row-button" @click="handleEdit(row)">编辑</Button>
        </template>
      </s-DataGrid>
      <div v-if="!isLoadGrid">
        <div>
          <div class="nodata">暂无数据</div>
        </div>
      </div>
    </Col>
    <Col span="8" style="background: #ebeef5; min-height: 200px; padding: 16px;">
      <div class="form" v-if="isLoadGrid">
          <Form :label-width="100" :model="codeFormData" ref="baseForm" label-colon>
              <Row>
                  <Col span="22">
                      <FormItem label="代码项" prop="code" :rules="{required: true, message: '代码项不能为空',trigger: 'blur' }">
                          <Input v-model="codeFormData.code" maxlength="50" show-word-limit />
                      </FormItem>
                  </Col>
                  <Col span="22">
                      <FormItem label="字典项" prop="name" :rules="{required: true, message: '字典项不能为空',trigger: 'blur' }">
                          <Input v-model="codeFormData.name" maxlength="500" show-word-limit />
                      </FormItem>
                  </Col>
                  <Col span="22">
                      <FormItem label="全 拼">
                          <Input v-model="codeFormData.scode" maxlength="500" show-word-limit />
                      </FormItem>
                  </Col>
                  <Col span="22">
                      <FormItem label="简 拼">
                          <Input v-model="codeFormData.jpCode" maxlength="500" show-word-limit />
                      </FormItem>
                  </Col>
                  <Col span="22">
                      <FormItem label="排 序" prop="orderId" :rules="{required: true, type: 'number', message: '排序不能为空',trigger: 'blur' }">
                          <InputNumber v-model="codeFormData.orderId" :min="1" :precision="0" :max="9999" style="width: 100%;" />
                      </FormItem>
                  </Col>
                  <Col span="22">
                      <FormItem label="备注">
                          <Input v-model="codeFormData.remark" maxlength="500" show-word-limit />
                      </FormItem>
                  </Col>
                  <Col span="22">
                      <FormItem label="是否禁用">
                          <RadioGroup v-model="codeFormData.isDisabled" size="large" >
                              <Radio label="1">是</Radio>
                              <Radio label="0">否</Radio>
                          </RadioGroup>
                      </FormItem>
                  </Col>
              </Row>
              <Row>
                  <Col span="22">
                  <div style="text-align:center;" class="bsp-base-small-fotter">
                      <Button size="small"  @click="handleAdd">重置</Button>
                      <Button type="primary" @click="handleSubmit">保 存</Button>
                  </div>
                  </Col>
              </Row>
          </Form>
      </div>
    </Col>
  </Row>
</template>

<script>
import { sDataGrid } from 'sd-data-grid'
import vPinyin from './vue-py.js'
export default {
    name: 'DicManage',
    components: {
        sDataGrid,
        vPinyin
    },
    props: {
        isRefApp: {
          type: Boolean,
          default: false,
          require: false
        },
        dicNames: {
          type: String,
          default: ''
        }
    },
    mounted() {
        this.init()        
    },
    data() {
        return {
            codeFormData: {
              dicId: '',
              dicName: '',
              dicCname: '',
              orderId: 1,
              isDisabled: '0'
            },
            gridParams: {
                dicId: ''
            },
            custom_loading: false,
            dicName: '',
            dicNameList: [],
            dicList: [],
            dicId: '',
            dicCname: '',
            dicMap: {},
            isLoadGrid: false,
            isDicNameChanged: false,
            gridOrderId: 1,
            jsLoading: false
        }
    },
    watch: {
        'codeFormData.name'() {
            if (this.codeFormData.name) {
                let pinyin = vPinyin.chineseToPinYin(this.codeFormData.name)
                this.$set(this.codeFormData, 'scode', pinyin)
                let SX = ''
                for (var i = 0; i < pinyin.length; i++) {
                    var c = pinyin.charAt(i)
                    if (/^[A-Z0-9]+$/.test(c)) {
                        SX += c
                    }
                }
                this.$set(this.codeFormData, 'jpCode', SX.toLowerCase())
            }
        }
    },
    methods: {
        //初始化
        init() {
          this.dicNameList = this.dicNames.split(',')
          if(this.dicNameList.length > 0){
            this.dicName = this.dicNameList[0]
            this.loadTargetDic(this.dicName)
          }
        },
        //加载目标字典
        loadTargetDic (name){
          this.dicId = ''
          this.dicList = []
          let params = {
            appId: this.isRefApp ? serverConfig.APP_ID : '',
            name: name
          }
          this.$store.dispatch('getRequest', { url: '/bsp-com/ops/dic/getDicDetailByNameAppId', params: params })
            .then(resp => {
              if (resp.success) {
                if(resp.data && resp.data.length > 0){
                  let firstDic = resp.data[0]
                  this.dicId = firstDic.id
                  this.dicCname = firstDic.cname
                  this.dicList = resp.data
                  this.dicMap = {}
                  this.dicList.forEach(e => {
                    this.dicMap[e.id] = e.cname
                  })                  
                  this.loadDataGrid(this.dicId)
                  this.isDicNameChanged = false
                }
              }
            })
        },
        //加载字典代码列表
        loadDataGrid(dicId){
          this.gridParams.dicId = dicId
          if(this.isLoadGrid){
            this.on_refresh_table()
          }
          else{
            this.isLoadGrid = true
          }
          this.handleAdd()
          this.isDicNameChanged = false
        },
        //源字典名称切换
        sourceChanged(obj) {
          this.isDicNameChanged = true
          this.loadTargetDic(obj)
        },
        //目标字典切换
        targetChanged(obj) {
          if(this.isDicNameChanged) return
          this.dicId = obj
          this.dicCname = this.dicMap[obj]
          this.loadDataGrid(obj)
        },
        handleReset() {
            this.$refs['baseForm'].resetFields();
        },
        handleAdd() {
          if(this.isLoadGrid){
            this.codeFormData = {}
            this.codeFormData.dicId = this.dicId
            this.codeFormData.dicName = this.dicName
            this.codeFormData.dicCname = this.dicCname
            this.codeFormData.isDisabled = '0'
            this.codeFormData.orderId = 1
          }
        },
        handleDeleteBatch() {
            if (this.$refs.grid.batch_select.length < 0) {
                this.$Notice.error({
                    title: '错误提示',
                    desc: '请选择要删除的字典代码项！'
                })
            } else {
                let idTemp = []
                this.$refs.grid.batch_select.forEach(e => {
                    idTemp.push(e.id)
                })
                this.handleDelete(idTemp.join(','))
            }
        },
        handleDelete(id) {
            let _this = this
            this.$Modal.confirm({
                title: '是否确认删除选中的代码项？',
                loading: true,
                onOk: async () => {
                    _this.submitDel(id)
                }
            })
        },
        submitDel(ids) {
            let _this = this
            this.$store.dispatch('postRequest', {
                url: '/bsp-com/ops/dic/code/deleteDicCode',
                params: {
                    ids: ids
                }
            }).then(data => {
                if (data.success) {
                    this.$Notice.success({
                        title: '成功提示',
                        desc: data.msg
                    })
                    _this.on_refresh_table()
                    if(_this.codeFormData.id && ids.indexOf(_this.codeFormData.id) != -1) {
                        _this.handleAdd()
                    }
                    _this.$Modal.remove()
                } else {
                    this.$Notice.error({
                        title: '错误提示',
                        desc: data.msg
                    })
                }
            })
        },
        on_refresh_table() {
            this.$refs.grid.query_grid_data(1)
        },
        handleEdit(row) {
            this.codeFormData = Object.assign({orderId: 1}, this.$tools.objToCamel(row))
        },
        on_show_table(isRefreshTable) {
            this.$emit('on_show_table', isRefreshTable)
        },
        handleSubmit() {
            this.$refs['baseForm'].validate(valid => {
                if (valid) {
                    this.save_code_data()
                } else {
                    this.$Notice.error({
                        title: '错误提示',
                        desc: '表单验证不通过'
                    })
                }
            })
        },
        save_code_data() {
            this.custom_loading = true
            this.$store.dispatch('postRequest', {
                url: '/bsp-com/ops/dic/code/saveDicCode',
                params: this.codeFormData
            }).then(data => {
                this.custom_loading = false
                if (data.success) {
                    this.$Notice.success({
                        title: '成功提示',
                        desc: data.msg
                    })
                    this.on_refresh_table()
                } else {
                    this.$Notice.error({
                        title: '错误提示',
                        desc: data.msg
                    })
                }
            })
        },
        buildJsUpdateCache() {
          if(this.dicId){
            this.jsLoading = true
            this.$store.dispatch('postRequest', {
                url: '/bsp-com/ops/dic/buildDicJs',
                params: {
                    ids: this.dicId
                }
            }).then(data => {
                if (data.success) {
                    this.$Notice.success({
                        title: '成功提示',
                        desc: data.msg
                    })
                    this.jsLoading = false
                } else {
                    this.$Notice.error({
                        title: '错误提示',
                        desc: data.msg
                    })
                    this.jsLoading = false
                }
            })
          }
          else{
            this.$Notice.error({
                title: '错误提示',
                desc: '未选中任何字典'
            })
          }
          
          console.log(this.dicId)
          console.log(this.dicName)
        }
    }
}
</script>

<style scoped>
.ivu-select-selection {
  border-radius: 8px !important;
  height: 40px;
  display: flex;
  align-items: center;
}

.ivu-select-input {
  text-align: center;
}

.ivu-select-arrow {
  color: #2d8cf0;
  transition: transform 0.3s;
}

.ivu-select-opened .ivu-select-arrow {
  transform: rotate(180deg);
}

.nodata {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  height: 300px;           /* 必须有高度 */
  border: 1px solid #ddd;
  font-size: 20px;
  font-weight: bold;
  color: red;
  text-align: center;
  width: 100%;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/component/dic-manage/dic-manage.vue